import { useState } from "react";
import {
  GetSymbolInfoQueryVariables,
  useGetSymbolInfoQuery,
} from "views/utils/graphql/graphql";

export const useGetSymbolDetail = (
  initVariables: GetSymbolInfoQueryVariables
) => {
  const [symbolDetailVariables, setSymbolDetailVariables] =
    useState<GetSymbolInfoQueryVariables>(initVariables);
  const [symbolDetail, getSymbolDetail] = useGetSymbolInfoQuery({
    variables: symbolDetailVariables,
    requestPolicy: "network-only",
  });
  return {
    symbolDetail,
    getSymbolDetail,
    setSymbolDetailVariables,
  };
};
